import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { CommonService } from '@product/shared/services/common.service';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.less'],
})
export class TagComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();

  color: string;
  constructor(private commonService: CommonService) {}

  ngOnInit(): void {}

  submit() {
    this.commonService.dropDownMetaData['Tags'] = [];
    this.submitChanges.emit();
  }

  recordLoaded(record: any) {}

  cleanRecord(record: any) : any{
    return record;
  }

  beforeSubmit() {}

  static controls(mode: string) {
    const controlsToReturn: any = {};
    if (mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Name'] = [null, [Validators.required]];

    return controlsToReturn;
  }
}
